'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002ecrud$0024$002dModal$002dView from "./presto.crud$-Modal-View.js";
var $p;
/** @constructor */
function $c_Lpresto_ViewGroupView(group) {
}
export { $c_Lpresto_ViewGroupView as $c_Lpresto_ViewGroupView };
$p = $c_Lpresto_ViewGroupView.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ViewGroupView;
/** @constructor */
function $h_Lpresto_ViewGroupView() {
}
export { $h_Lpresto_ViewGroupView as $h_Lpresto_ViewGroupView };
$h_Lpresto_ViewGroupView.prototype = $p;
$p.bP = (function() {
  return $j_presto$002ecrud$0024$002dModal$002dView.$f_Lpresto_crud$ModalView__isDisabled__Lcom_raquo_airstream_core_Signal(this);
});
$p.bR = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Predef$().uJ();
});
$p.bE = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.n().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, "DISABLED", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().m)]))));
});
var $d_Lpresto_ViewGroupView = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ViewGroupView, "presto.ViewGroupView", ({
  Vm: 1,
  J: 1
}));
export { $d_Lpresto_ViewGroupView as $d_Lpresto_ViewGroupView };
//# sourceMappingURL=presto.-View-Group-View.js.map
